// extracted by mini-css-extract-plugin
export var cardHeader = "_gt-1";
export var contentCard = "_gt-0";
export var headerActions = "_gt-3";
export var reorderHandle = "_gt-5";
export var titleArea = "_gt-2";
export var titleAreaWithHandle = "_gt-4";